import { Navigate, useParams } from 'react-router-dom';
export default function Upp() { const { lang = 'en' } = useParams(); return <Navigate to={`/${lang}/servicepolicy`} replace />; }
